<script setup lang="ts">
withDefaults(
  defineProps<{
    /** rect | circle | text | title | button | input */
    variant?: 'rect' | 'circle' | 'text' | 'title' | 'button' | 'input'
    width?: string
    height?: string
    radius?: string
    inline?: boolean
  }>(),
  {
    variant: 'rect',
    width: '100%',
    height: undefined,
    radius: undefined,
    inline: false,
  },
)

const variantHeight: Record<string, string> = {
  text: '14px',
  title: '18px',
  button: '32px',
  input: '36px',
  rect: '16px',
  circle: '40px',
}

const variantRadius: Record<string, string> = {
  text: '6px',
  title: '6px',
  button: '8px',
  input: '8px',
  rect: '8px',
  circle: '50%',
}
</script>

<template>
  <span
    class="sk-block"
    :class="[`sk-block--${variant}`, { 'sk-block--inline': inline }]"
    :style="{
      width,
      height: height ?? variantHeight[variant],
      borderRadius: variant === 'circle' ? '50%' : (radius ?? variantRadius[variant]),
    }"
    aria-hidden="true"
  />
</template>
